import React from 'react'

const NotFound = () => {
  return (
    <div className='text-white'>NotFound</div>
  )
}

export default NotFound